<template>
  <div>
    <div class="row vertical-align-center">
      <div class="col-sm-5">
        <div class="row vertical-align-center">
          <div class="dataTables_length col-sm-4" id="example1_length">
            <label>Show
              <select v-on:change="showSizeChange" name="example1_length" aria-controls="example1"
                class="form-control input-sm">
                <!--<option value="2">2</option>-->
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select> entries
            </label>
          </div>

          <div class="btn-group" v-if="selectedTestimonies && selectedTestimonies.length">
            <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              Mark {{ selectedTestimonies.length }} selected as &nbsp;<span class="caret"></span>
            </button>
            <ul class="dropdown-menu">
              <li><a @click="updateTestimoniesStatus('READ')"><i class="fa fa-fw fa-envelope-open"></i>Read</a></li>
              <li><a @click="updateTestimoniesStatus('UNREAD')"><i class="fa fa-fw fa-envelope"></i>Unread</a></li>
              <li><a @click="updateTestimoniesStatus('PROCESSING')"><i class="fa fa-fw fa-balance-scale"></i>Processing
                  ...</a></li>
              <li><a @click="updateTestimoniesStatus('PROCESSED')"><i class="fa fa-fw fa-check"></i>Processed</a></li>
              <li role="separator" class="divider"></li>
              <li><a @click="clearSelection()"><i class="fa fa-fw fa-ban"></i>Clear selection</a></li>
            </ul>
          </div>

          <button class="btn btn-default col-sm-offset-1 col-sm-2 filter-btn" type="button" data-toggle="collapse"
            data-target="#filters" aria-expanded="false" aria-controls="collapseExample">
            Filters
          </button>
        </div>
      </div>

      <div class="col-sm-6 search-table" v-if="searchEnabled">
        <div id="example1_filter" class="dataTables_filter">
          <input type="search" class="form-control input-sm" v-model="query" v-on:change="searchChange"
            placeholder="Syria" aria-controls="example1">
          <button type="submit" class="btn btn-flat btn-primary search-btn" v-on:click="search">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="row filters-row">
      <div class="col-sm-12 collapse filters" id="filters">
        <div class="card card-body">
          <form class="form-inline">
            <label>Get only testimonies created after</label>
            <div class="form-control date-control">
              <datepicker v-model="startCreationDate" :clear-button="true" format="MM/dd/yyyy"></datepicker>
            </div>

            <label>and before</label>
            <div class="form-control date-control">
              <datepicker v-model="endCreationDate" :clear-button="true" format="MM/dd/yyyy"></datepicker>
            </div>
          </form>
          <form class="form-inline">
            <label>And attack occured after</label>
            <div class="form-control date-control">
              <datepicker v-model="startAttackDate" :clear-button="true" format="MM/dd/yyyy"></datepicker>
            </div>

            <label>and before</label>
            <div class="form-control date-control">
              <datepicker v-model="endAttackDate" :clear-button="true" format="MM/dd/yyyy"></datepicker>
            </div>
          </form>
          <tags-search ref="tags-search"></tags-search>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 table-responsive">

        <table role="grid" class="table table-bordered table-striped dataTable">
          <thead>
            <tr role="row">
              <th></th>
              <th></th>
              <th v-on:click="sortBy('creationDate', 'true')" v-bind:class="{ active: sortField === 'creationDate' }"
                aria-label="Creation date" aria-sort="ascending" colspan="1" rowspan="1" aria-controls="example1"
                tabindex="0" class="sorting_asc">Creation Date</th>
              <!-- <th aria-label="Firstname" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Firstname</th> -->
              <th aria-label="Purpose" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Purpose</th>
              <th aria-label="Lastname" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Victim name</th>
              <th aria-label="Minor" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Minor</th>
              <th aria-label="Gender" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Gender</th>
              <th v-on:click="sortBy('actionPeriod.startDate', 'true')"
                v-bind:class="{ active: sortField === 'actionPeriod.startDate' }" aria-label="Attack date" colspan="1"
                rowspan="1" aria-controls="example1" tabindex="0" class="sorting_asc">Attack date</th>
              <th aria-label="Attack time" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Attack time
              </th>
              <th aria-label="Place" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Place</th>
              <th aria-label="Origin" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Origin</th>
              <th v-on:click="sortBy('similarNumbers', 'true')" v-bind:class="{ active: sortField === 'similarNumbers' }"
                aria-label="Similar case" colspan="1" rowspan="1" aria-controls="example1" tabindex="0"
                class="sorting_asc">Similar</th>
              <th aria-label="Tags" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Tags</th>
              <th aria-label="Tags" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">Code</th>
            </tr>
          </thead>
          <div v-if="testimonies.length === 0" class="no-data">No data found</div>
          <tbody v-else>
            <tr :class="testimony.status === 'UNREAD' ? 'unread' : ''" role="row" v-for="testimony in testimonies"
              v-on:click="goTo(testimony)">
              <td class="text-center" v-on:click.stop="toggleSelection($event, testimony)">
                <input type="checkbox" :checked="selectedTestimonies.indexOf(testimony._id) !== -1">
              </td>
              <td class="text-center">
                <i v-if="testimony.status === 'UNREAD'" class="fa fa-envelope" title="Unread"></i>
                <i v-else-if="testimony.status === 'PROCESSING'" class="fa fa-balance-scale" title="Processing ..."></i>
                <i v-else-if="testimony.status === 'PROCESSED'" class="fa fa-check" title="Processed"></i>
              </td>
              <td class="sorting_1">{{ testimony.creationDate | prettyDateTime }}</td>
              <td><span v-if="testimony.purpose">{{ testimony.purpose }}</span></td>
              <td><span v-if="testimony.victimIdentity">{{ testimony.victimIdentity.name }}</span></td>
              <td>{{ testimony.victimIdentity && testimony.victimIdentity.minor ? 'Yes' : 'No' }}</td>
              <td><span v-if="testimony.victimIdentity">{{ testimony.victimIdentity.gender }}</span></td>
              <td>
                <span v-if="testimony.actionPeriod">
                  {{ testimony.actionPeriod.startDate | prettyDate }}
                </span>
              </td>
              <td>
                <span v-if="testimony.actionPeriod">
                  {{ testimony.actionPeriod.startTime | prettyTime }}
                </span>
              </td>
              <td>
                <span v-if="testimony.actionDetail && testimony.actionDetail.actionLocation">
                  {{ testimony.actionDetail.actionLocation.zone }}
                </span>
              </td>
              <td>
                {{ testimony.originInfo? testimony.originInfo.origin : 'UNKNOWN'}}
              </td>
              <td>{{ testimony.similarNumbers }}</td>
              <td>
                <span v-for="tag in tagsByTestimony[testimony._id]" class="label label-default"
                  v-on:click.stop="searchByTag(tag)">{{ tag }}</span>
              </td>
              <td>
                {{ testimony.randomId }}
              </td>
            </tr>
          </tbody>
          <!-- <tfoot>
              <tr>
                <th colspan="1" rowspan="1">Creation Date</th>
                <th colspan="1" rowspan="1">Firstname</th>
                <th colspan="1" rowspan="1">Name</th>
                <th colspan="1" rowspan="1">Minor</th>
                <th colspan="1" rowspan="1">Gender</th>
                <th colspan="1" rowspan="1">Attack date</th>
                <th colspan="1" rowspan="1">Attack time</th>
                <th colspan="1" rowspan="1">Place</th>
                <th colspan="1" rowspan="1">Similar</th>
              </tr>
            </tfoot> -->
        </table>
      </div>
    </div>
    <div class="row" v-if="testimonies.length > 0">
      <div class="align-infos col-sm-12">
        <div class="dataTables_info" id="example1_info" role="status" aria-live="polite">Showing
          {{ total - testimonies.length + 1 > page * size + 1 ? page * size + 1 : total - testimonies.length + 1 }}
          to {{ total > (page + 1) * size ? (page + 1) * size : total }} of {{ total }} entries
        </div>
      </div>
      <div class="table-pagination col-sm-12">
        <paginate :page-count="pageTotal" :page-range="3" :margin-pages="2" :click-handler="changePage"
          :prev-text="'Prev'" :force-page="page" :next-text="'Next'" :container-class="'pagination'"
          :page-class="'page-item'">
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import api from '../../api'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

export default {
  name: 'TestimoniesList',
  props: ['globalEnpoint', 'searchEndpoint', 'searchEnabled', 'additionalQueryParam'],
  components: { Multiselect },
  data () {
    return {
      testimonies: [],
      selectedTestimonies: [],
      tagsByTestimony: {},
      startCreationDate: null,
      endCreationDate: null,
      startAttackDate: null,
      endAttackDate: null,
      query: null,
      size: 10,
      pageTotal: 0,
      total: 0,
      page: 0,
      sortField: 'creationDate',
      desc: 'true'
    }
  },
  methods: {
    goTo (testimony) {
      const id = testimony._id ? testimony._id : testimony.id // TODO because of search result (ES expects an id field named 'id'). TO REFACTO
      this.$router.push({ name: 'Testimony', params: { id: id } })
    },
    sortBy (sortField, desc) {
      this.sortField = sortField
      this.desc = desc
      this.refresh(true)
    },
    changePage (pageNum) {
      this.page = pageNum - 1
      this.refresh()
    },
    showSizeChange (e) {
      this.size = e.target.value
      this.refresh(true)
    },
    refresh (toFirstPage = false) {
      if (toFirstPage) {
        this.page = 0
      }

      this.getTagsGroupByTestimony()

      if (this.$route.query.tag) {
        this.searchByTag(this.$route.query.tag)
      } else if (!this.isSearch()) {
        this.getTestimonies()
      } else {
        this.search(false)
      }
    },
    searchChange (e) {
      this.refresh(true)
    },
    searchByTag (tagName) {
      this.$refs['tags-search'].selected = [{ name: tagName }]
      let endpoint = `${this.searchEndpoint}?q=*&size=${this.size}&page=0&sortField=${this.sortField}&desc=${this.desc}${this.additionalQueryParam}&tag=${tagName}`
      api.authenticatedRequest('get', endpoint)
        .then(response => {
          const data = response.data
          this.testimonies = data.data
          this.total = data.total
          this.pageTotal = Math.ceil(this.total / this.size)
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401) { // InvalidCredentialsError
            this.response = 'Username/Password incorrect. Please try again.'
            return
          }
          this.response = 'Server appears to be offline'
        })
    },
    isSearch () {
      return (this.query !== null && this.query !== '' ||
        this.startCreationDate !== null && this.startCreationDate !== '' ||
        this.endCreationDate !== null && this.endCreationDate !== '' ||
        this.startAttackDate !== null && this.startAttackDate !== '' ||
        this.endAttackDate !== null && this.endAttackDate !== '' ||
        this.$refs['tags-search'].selected.size > 0)
    },
    search (isNewSearch = true) {
      if (isNewSearch) {
        this.page = 0
      }
      let endpoint = `${this.searchEndpoint}?q=${this.query === null || this.query === '' ? '*' : this.query}&size=${this.size}&page=${this.page}&sortField=${this.sortField}&desc=${this.desc}${this.additionalQueryParam}`
      if (this.startCreationDate) {
        endpoint += `&startCreationDate=${moment(this.startCreationDate).format('MM/DD/YYYY')}`
      }
      if (this.endCreationDate) {
        endpoint += `&endCreationDate=${moment(this.endCreationDate).format('MM/DD/YYYY')}`
      }
      if (this.startAttackDate) {
        endpoint += `&startAttackDate=${moment(this.startAttackDate).format('MM/DD/YYYY')}`
      }
      if (this.endAttackDate) {
        endpoint += `&endAttackDate=${moment(this.endAttackDate).format('MM/DD/YYYY')}`
      }
      this.$refs['tags-search'].selected.forEach(tag => {
        endpoint += `&tag=${tag.name}`
      })
      api.authenticatedRequest('get', endpoint)
        .then(response => {
          const data = response.data
          this.testimonies = data.data
          this.total = data.total
          this.pageTotal = Math.ceil(this.total / this.size)
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401) { // InvalidCredentialsError
            this.response = 'Username/Password incorrect. Please try again.'
            return
          }
          this.response = 'Server appears to be offline'
        })
    },
    getTestimonies () {
      /* Making API call to authenticate a user */
      api.authenticatedRequest('get', `${this.globalEnpoint}?size=${this.size}&page=${this.page}&sortField=${this.sortField}&desc=${this.desc}${this.additionalQueryParam}`)
        .then(response => {
          const data = response.data
          this.testimonies = data.data
          this.total = data.total
          this.pageTotal = Math.ceil(this.total / this.size)
          this.$emit('loaded', this.testimonies)
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401) { // InvalidCredentialsError
            this.response = 'Username/Password incorrect. Please try again.'
            return
          }
          this.response = 'Server appears to be offline'
        })
    },
    getTagsGroupByTestimony () {
      api.authenticatedRequest('get', '/tags?groupBy=testimonyId')
        .then(response => {
          response.data.forEach(item => {
            this.tagsByTestimony[item.occurrenceId] = item.tags
          })
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401) { // InvalidCredentialsError
            this.response = 'Username/Password incorrect. Please try again.'
            return
          }
          this.response = 'Server appears to be offline'
        })
    },
    updateTestimoniesStatus (status) {
      api.authenticatedRequest('patch', '/testimonies/_update-status', { ids: this.selectedTestimonies, status: status })
        .then(() => {
          if (this.isSearch()) {
            // Workaround for ES sync delay
            this.selectedTestimonies.forEach(testimonyId => {
              api.authenticatedRequest('get', `/testimonies/${testimonyId}?read=false`).then((data) => {
                const testimony = data.data
                this.testimonies = this.testimonies.map(item => item._id === testimony._id ? testimony : item)
              })
            })
          } else {
            this.refresh()
          }
          this.clearSelection()
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401) { // InvalidCredentialsError
            this.response = 'Username/Password incorrect. Please try again.'
            return
          }
          this.response = 'Server appears to be offline'
        })
    },
    toggleSelection ($event, testimony) {
      const $ = window.jQuery
      const $target = $($event.target)
      const $toggle = $target.closest('td').find('input:checkbox')

      // Manually toggle checkbox state if change not triggered by it
      if (!$target.is('input:checkbox')) {
        $toggle.prop('checked', !$toggle.is(':checked'))
      }

      const testimonyIndex = this.selectedTestimonies.indexOf(testimony._id)
      if ($toggle.is(':checked') && testimonyIndex === -1) {
        this.selectedTestimonies.push(testimony._id)
      } else if (!$toggle.is(':checked') && testimonyIndex > -1) {
        this.selectedTestimonies.splice(testimonyIndex, 1)
      }
    },
    clearSelection () {
      this.selectedTestimonies = []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.refresh()
    })
  }
}
</script>
<style>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/
@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

table.dataTable thead {
  cursor: default;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: "Font Awesome 5 Free";
}

table.dataTable thead .sorting_asc:focus,
table.dataTable thead .sorting_desc:focus {
  outline: none;
}

table.dataTable thead .active:after {
  opacity: 0.5 !important;
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
  opacity: 0.2;
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
  opacity: 0.2;
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
  opacity: 0.2;
}

table.dataTable td {
  cursor: pointer;
}

table.dataTable tbody tr:hover {
  background-color: #eee;
}

table.dataTable .no-data {
  text-align: center;
  height: 37px;
  display: table-caption;
  caption-side: bottom;
  padding-top: 7px;
}

.dataTables_length label {
  margin: 0;
}

.date-control {
  border: 0
}

.dataTables_filter {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}

.dataTables_filter button {
  height: 100%;
  border-top-right-radius: 3px !important;
  border-bottom-right-radius: 3px !important;
}

.filters-row {
  margin-left: -11px;
  margin-right: -11px;
}

.filters {
  padding-top: 10px;
  padding-bottom: 10px;
}

.filters button {
  height: 30px;
}

.vertical-align-center {
  display: flex;
  align-items: center;
}

.filter-btn {
  justify-content: center !important;
  margin: auto !important;
}

.search-btn:active:focus,
.filter-btn:active:focus {
  outline: none;
}

.vdp-datepicker input {
  border: 1px solid #d2d6de;
}

.search-table {
  height: 34px;
}

.dataTables_filter input {
  border-top-left-radius: 3px !important;
  border-bottom-left-radius: 3px !important;
  height: auto !important;
  line-height: 1.45 !important;
  color: #555 !important;
  background-color: #fff !important;
  border: 1px solid #ccc !important;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  display: inline-block !important;
  padding: 6px 12px !important;
  margin-bottom: 0 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  white-space: nowrap !important;
  vertical-align: middle !important;
  width: 50% !important;
  margin-right: -1px;
}

.align-infos {
  display: flex;
  justify-content: flex-end;
  padding-right: 15px;
  text-align: end;
}

.pagination {
  margin-top: 0;
  display: inline-flex;
  justify-content: center;
}

.table-pagination {
  display: flex;
  justify-content: center;
}

.label+.label {
  margin-left: 5px;
}

.btn-group>ul>li>a {
  cursor: pointer;
}

tr.unread {
  font-weight: bold;
}

td .fa-check {
  /* color: #5cb85c */
}
</style>



// WEBPACK FOOTER //
// TestimoniesList.vue?5537e3ba